import React from 'react';
import { useRecoilState } from 'recoil';

import useTeeshotApiRequest from './use-teeshotApiRequest';
import { commonState } from '../recoil/commonState';
import { Suspense, useEffect } from 'react';

export default function useCommonData() {
    const [initialCommonData, setCommonData] = useRecoilState(commonState);
    const { request } = useTeeshotApiRequest();

    useEffect(() => {
        (async () => {
            const data = await request({
                method: 'GET',
                url: `/common/groupBooking`,
            });
            setCommonData({ ...initialCommonData, ...data });
        })();
    }, []);
}
